export default async (query, variables = null) => {
  const response = await fetch(`https://${window.Shopify.shop}/api/${window.theme.api.shopifyStorefront.version}/graphql.json`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': window.theme.api.shopifyStorefront.publicAccessKey,
    },
    body: JSON.stringify({
      query,
      // variables: {
      //   now: new Date().toISOString(),
      // },
    }),
  });

  return response;
};
